<footer class="page-footer-container page-footer">
    <div class="container">
        <ul [hidden]="!innerSiteNavigation" class="list-inline">
            <li class="list-inline-item">
                <a [translate]="'common.cookie_policy'" [routerLink]="['/cookiePolicy']"></a>
            </li>
            <li class="list-inline-item">|</li>
            <li class="list-inline-item">
                <a [translate]="'common.privacy_policy'" [routerLink]="['/privacyPolicy']"></a>
            </li>
        </ul>
        <ul [hidden]="innerSiteNavigation" class="list-inline">
            <li class="list-inline-item">
                <a [translate]="'common.cookie_policy'" [href]="cookiePolicyUrl"></a>
            </li>
            <li class="list-inline-item">|</li>
            <li class="list-inline-item">
                <a [translate]="'common.privacy_policy'" [href]="privacyPolicyUrl"></a>
            </li>
        </ul>
        <ul class="list-inline">
            <li class="list-inline-item">
                <span [translate]="'common.all_right_reserved'"></span>
            </li>
            <li class="list-inline-item">|</li>
            <li class="list-inline-item">
                <a [href]="developerCompanyUrl">{{ developerCompanyDomain }}</a>
            </li>
        </ul>
    </div>
</footer>
